import recommendationsModule from '../recommendationsModule.js';

const carouselComponent = {
  templateUrl: 'carousel',
  controller: 'carouselController',
  bindings: {
    items: '=',
    variation: '<?'
  }
};

recommendationsModule.component('carousel', carouselComponent);
export default carouselComponent;
